import Layout from "../../components/layout/Layout";
import Navbar from "../../components/layout/header/Navbar";
import Hero from "./Hero";
import WhyParticipate from "../../components/why-participate/WhyParticipate";
import WhyChooseUs from "../../components/why-choose-us/WhyChooseUs";
import HomeVideoOverview from "../../components/home-video/HomeVideoOverview";
import HomeVideoOverviewV2 from "../../components/home-video/HomeVideoOverviewV2";
import Footer from "../../components/layout/footer/Footer";

export default function Home({ information }) {
  return (
    <Layout>
      <Navbar darkBg information={information} />
      <Hero />
      <WhyParticipate />
      <WhyChooseUs />
      <HomeVideoOverviewV2 />
      {/* <HomeVideoOverview /> */}
      <Footer space information={information} />
    </Layout>
  );
}
